/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import { Image } from './core';
import MediaQueries from '../constants/MediaQueries';
import withBreakpoint from './withBreakpoint';

const IMAGES = {
  small: {
    pickup: {
      src: require('../../assets/images/home-road-pickup-small.png'),
      src2x: require('../../assets/images/home-road-pickup-small_2x.png'),
    },
    'pickup-short': {
      src: require('../../assets/images/home-road-pickup-small.png'),
      src2x: require('../../assets/images/home-road-pickup-small_2x.png'),
    },
    dropoff: {
      src: require('../../assets/images/home-road-dropoff-small.png'),
      src2x: require('../../assets/images/home-road-dropoff-small_2x.png'),
    },
  },
  xlarge: {
    pickup: {
      src: require('../../assets/images/home-road-pickup-xlarge.png'),
      src2x: require('../../assets/images/home-road-pickup-xlarge_2x.png'),
    },
    'pickup-short': {
      src: require('../../assets/images/home-road-pickup-short-xlarge.png'),
      src2x: require('../../assets/images/home-road-pickup-short-xlarge_2x.png'),
    },
    dropoff: {
      src: require('../../assets/images/home-road-dropoff-xlarge.png'),
      src2x: require('../../assets/images/home-road-dropoff-xlarge_2x.png'),
    },
  },
};

function Road({
  enrouteTo = 'pickup',
  breakpoint,
}: {
  enrouteTo: 'pickup' | 'dropoff' | 'pickup-short',
  breakpoint: string,
}) {
  let sources = breakpoint === 'small' ? IMAGES['small'][enrouteTo] : IMAGES['xlarge'][enrouteTo];

  return <Image {...sources} className={Styles.Image} />;
}

const Styles = {
  Image: css`
    margin: 40px 0;
    max-width: 82px;
    width: 100%;
    ${MediaQueries.Medium} {
      margin: 60px 0;
      max-width: 960px;
    }
  `,
};

export default withBreakpoint(Road);



// WEBPACK FOOTER //
// ./src/ui/components/Road.js